// src/components/ui/textarea.jsx

import * as React from "react";
import { cn } from "@/lib/utils";

const Textarea = React.forwardRef(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border bg-background px-3 py-2 text-sm text-text transition-colors",
          "border-neutral-dark/30",
          "placeholder:text-neutral-dark/60",
          "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 focus:border-primary",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-light",
          "resize-none",
          error && "border-danger focus:ring-danger",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
